var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacances1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #adb08d;\n      }\n\n      .cls-2 {\n        fill: #585a3f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.23,
    y: -0.7,
    width: 60.49,
    height: 59.89
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.48,19.89c1.79,0,3.24,1.15,3.24,2.94v16.18c0,1.79-1.45,3.24-3.24,3.24h-24.96c-1.79,0-3.24-1.45-3.24-3.24v-16.18c0-1.79,1.45-2.94,3.24-2.94l4.3.02v-2.61c0-1.79,1.22-3.56,3.01-3.56h10.34c1.79,0,2.85,1.77,2.85,3.56v2.61l4.46-.02ZM22.44,17.01v2.9h13.13v-2.82c0-.85-.69-1.83-1.53-1.83h-10.14c-.8,0-1.45.95-1.45,1.76ZM43.29,38.81v-4.23c-2.89,0-6.11,3.21-6.11,6.16h4.18c1.07,0,1.93-.87,1.93-1.93ZM16.64,40.74h4.18c0-2.95-3.22-6.16-6.11-6.16v4.23c0,1.07.87,1.93,1.93,1.93ZM43.29,33.1h0v-4.03c-3.97-.52-7.12-3.67-7.64-7.64h-13.3c-.52,3.97-3.67,7.12-7.64,7.64v4.03c3.97.52,7.12,3.67,7.64,7.64h13.3c.52-3.97,3.67-7.12,7.64-7.64ZM29,26.84c2.34,0,4.25,1.91,4.25,4.25s-1.91,4.25-4.25,4.25-4.25-1.91-4.25-4.25,1.91-4.25,4.25-4.25ZM29,34.15c1.69,0,3.06-1.37,3.06-3.06s-1.37-3.06-3.06-3.06-3.06,1.37-3.06,3.06,1.37,3.06,3.06,3.06ZM41.56,21.42h-4.38c0,2.95,3.22,6.16,6.11,6.16v-4.43c0-.95-.77-1.73-1.73-1.73ZM14.71,22.95v4.63c2.89,0,6.11-3.21,6.11-6.16h-4.58c-.84,0-1.53.68-1.53,1.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacances1);
export default __webpack_public_path__ + "static/media/Vacances (1).5554711029507b85387e38656c5b992b.svg";
export { ForwardRef as ReactComponent };